import { createApi } from '@reduxjs/toolkit/query/react'
import getQuery from '../../helpers/api/get-query'
import RewindJob from '../../types/api/rewind-job'
import Strapi, {
    EndpointQueryParameters,
    StrapiCreate,
    StrapiSingle,
    StrapiUpdate,
} from '../../types/strapi/strapi'
import getCustomFetchBase from '../custom-fetch-base'

export const rewindJobsApi = createApi({
    reducerPath: 'rewindJobsApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['RewindJobs'],
    endpoints: builder => ({
        getRewindJobs: builder.query<Strapi<RewindJob>, EndpointQueryParameters | void>({
            query: getQuery('/rewind-jobs'),
            providesTags: ['RewindJobs'],
        }),
        createRewindJob: builder.mutation<StrapiSingle<RewindJob>, StrapiCreate<RewindJob>>({
            query: body => ({
                url: '/rewind-jobs',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['RewindJobs'],
        }),
        updateRewindJob: builder.mutation<StrapiSingle<RewindJob>, StrapiUpdate<RewindJob>>({
            query: ({ docId, body }) => ({
                url: `/rewind-jobs/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['RewindJobs'],
        }),
    }),
})

export const {
    useGetRewindJobsQuery,
    useCreateRewindJobMutation,
    useUpdateRewindJobMutation,
} = rewindJobsApi
